import { render } from "./PanelTabs.vue?vue&type=template&id=1c6c24a4"
import script from "./PanelTabs.vue?vue&type=script&lang=js"
export * from "./PanelTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__